"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Tooltip = (props) => {
    const { children, text, width, position, className } = props;
    const nPos = position || 'bottom';
    const nPosClass = `glx-tooltip-content-${nPos}`;
    const [open, setOpen] = (0, react_1.useState)(false);
    const [left, setLeft] = (0, react_1.useState)(0);
    const chRef = (0, react_1.createRef)();
    const tRef = (0, react_1.createRef)();
    const nWidth = width || 200;
    (0, react_1.useEffect)(() => {
        const w = chRef.current?.offsetWidth || 0;
        const tw = tRef.current?.offsetWidth || 0;
        let nw = 0;
        switch (nPos) {
            case 'bottom':
                nw = (-tw + w) * 0.5;
                break;
            case 'right':
                nw = w;
                break;
            case 'left':
                nw = -nWidth - 10;
                break;
            default:
        }
        setLeft(nw);
    }, [chRef, open]);
    return (react_1.default.createElement("span", { className: `glx-tooltip-container ${className}` },
        react_1.default.createElement("span", { ref: chRef, className: "glx-tooltip-children", onMouseEnter: (el) => setOpen(true), onMouseLeave: (el) => setOpen(false) }, children),
        text ? (react_1.default.createElement("div", { ref: tRef, style: {
                left: `${left}px`,
                display: open ? 'block' : 'none',
                width: nWidth,
            }, className: `glx-tooltip-content glx-fade-in-fast ${nPosClass}` }, text)) : null));
};
Tooltip.defaultProps = {
    width: undefined,
    position: undefined,
    className: '',
    text: undefined,
    children: undefined,
};
exports.default = Tooltip;
